import { render, staticRenderFns } from "./AnnoPanel.vue?vue&type=template&id=002c45af&scoped=true&lang=pug"
import script from "./AnnoPanel.vue?vue&type=script&lang=js"
export * from "./AnnoPanel.vue?vue&type=script&lang=js"
import style0 from "./AnnoPanel.vue?vue&type=style&index=0&id=002c45af&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002c45af",
  null
  
)

export default component.exports